// extracted by mini-css-extract-plugin
module.exports = {"box":"box-h-N7S5NR","ad":"ad-3oH9r-Dc"};